<template>
  <div class="panel-body panel-body-with-table">
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th width="25%">Username</th>
            <th width="25%">Email</th>
            <th width="25%">Last and first name</th>
            <th width="5%">COV19 enabled</th>
            <th width="20%"></th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td colspan="3">
              <input
                type="text"
                v-on:keyup="filterUsersByNameEmail"
                placeholder="Filter by username, email, last and first name..."
                v-model="filterByNameEmail"
                class="form-control form-control-sm"
              />
            </td>
            <td>
              <select
                class="form-control form-control-sm"
                v-on:change="filterUsersByCOV19Status()"
                v-model="filterByCOV19Status"
              >
                <option value="">All</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </td>
            <td></td>
          </tr>

          <tr v-for="user in users.data" :key="user.id">
            <td>{{ user.name }}</td>
            <td>{{ user.email }}</td>
            <td>{{ user.slug }}</td>
            <td>{{ user.is_cov19_enabled ? "Yes" : "No" }}</td>
            <td>
              <form
                method="POST"
                :action="route('users.user.destroy', [user.id])"
                accept-charset="UTF-8"
              >
                <input name="_method" value="DELETE" type="hidden" />
                <input type="hidden" name="_token" :value="csrf">
                <!--{{ csrf_field() }}-->

                <div class="btn-group btn-group-xs pull-right" role="group">
                  <a
                    :href="route('users.user.show', [user.id])"
                    class="btn btn-info"
                    title="Show user"
                  >
                    <span>Show</span>
                  </a>

                  <a
                    :href="route('users.user.edit', [user.id])"
                    class="btn btn-warning"
                    title="Edit user"
                  >
                    <span>Edit</span>
                  </a>

                  <button
                    type="submit"
                    class="btn btn-danger"
                    title="Delete user"
                    onclick='return confirm("Click OK to delete user.")'
                  >
                    <span>Delete</span>
                  </button>
                </div>
              </form>
            </td>
          </tr>
        </tbody>
</table>
        <pagination
          :data="users"
          @pagination-change-page="getResults"
          v-show="filterOff"
        ></pagination>

    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  data() {
    return {
      users: {},
      filterByNameEmail: "",
      filterByCOV19Status: "",
      filterOff: true,
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    };
  },

  methods: {
    fetchingAllUsers() {
      axios.get("api/user").then((data) => (this.users = data.data));
    },

    getResults(page = 1) {
      axios.get("api/user?page=" + page).then((response) => {
        this.users = response.data;
      });
    },

    filterUsersByNameEmail: _.debounce(function () {
      this.filterByCOV19Status = "";
      if (this.filterByNameEmail == "") {
        this.filterOff = true;
        axios.get("api/user?page=1", { timeout: 1000 }).then((response) => {
          this.users = response.data;
        });
      } else {
        this.filterOff = false;
        axios
          .get("/filter-users-by-name-email?q=" + this.filterByNameEmail,{ timeout: 1000 })
          .then((response) => {
            this.users.data = response.data.user;
          });
      }
    }),

    filterUsersByCOV19Status: _.debounce(function () {
      this.filterByNameEmail = "";
      if (this.filterByCOV19Status == "") {
        this.filterOff = true;
        axios.get("api/user?page=1", { timeout: 1000 }).then((response) => {
          this.users = response.data;
        });
      } else {
        this.filterOff = false;
        axios
          .get("/filter-users-by-cov19-status?q=" + this.filterByCOV19Status, { timeout: 1000 })
          .then((response) => {
            this.users.data = response.data.user;
          });
      }
    }),
  },

  created() {
    this.fetchingAllUsers();
  },

  deleteUser(id) {
    this.axios
      .delete(`http://localhost:8000/api/user/delete/${id}`)
      .then((response) => {
        let i = this.users.map((item) => item.id).indexOf(id); // find index of your object
        this.users.splice(i, 1);
      });
  },
};
</script>
